import MacroCategoryOrder from "./MacroCategoryOrder";

function GetMacroCategoryOrder(category, moduleName = "") {
    if (process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === category) {
        return MacroCategoryOrder[moduleName]?.customOrderOralCare || null;
    } else if (process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === category) {
        return MacroCategoryOrder[moduleName]?.customOrderSkinCleansing || null;
    } else if (process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === category) {
        return MacroCategoryOrder[moduleName]?.customOrderUnileverFragranceHouse || null;
    } else {
        return MacroCategoryOrder[moduleName]?.customOrder || null;
    }
}
export default GetMacroCategoryOrder;
